import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import ModalDialog from '../modal-dialog/modal-dialog.component';
import { HeaderSecondary } from '../typography/typography.styles';
import { ModalIconBody } from '../modal-dialog/modal-dialog.styles';
import { useIsMobile } from '../../hooks/use-is-mobile.hook';
import Button from '../button/button.component';
import QrCode from '../qr-code/qr-code.component';

interface Props {
  isOpen: boolean;
  qrValue: string;
  onClose: () => void;
}
const getQRIcon = (value: string, onClick: () => void) => (
  <QrCode
    value={value}
    size='fill'
    onClick={() => onClick()}
  />
);
const QRCodeModal = ({ isOpen = false, qrValue, onClose }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleRedirect = () => {
    window.open(qrValue, '_blank');
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      displayButtons={false}>
      <HeaderSecondary>{t('scan_qr_modal')}</HeaderSecondary>
      <ModalIconBody>{getQRIcon(qrValue, handleRedirect)}</ModalIconBody>
      {isMobile && (
        <Button
          onClick={handleRedirect}
          appearance='text'
          $pb='0'
          $pt='16px'
          className='mobile-qr-popup-link'>
          {t('download_now')}
        </Button>
      )}
    </ModalDialog>
  );
};

export default observer(QRCodeModal);
